var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Container",attrs:{"data-margin":_vm.matchEntities(['NETHERLANDS', 'POLAND'])}},[_c('FindStationScreen'),_c('ArrivingToStation'),(!_vm.matchEntities(['NETHERLANDS', 'POLAND']))?_c('ChargePointTutorial'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }